import React from 'react'

export default function ProofTemplateContent  ({ img }) {
    return (
        <div style={{ aspectRatio: '335/270' }}>
            <img
                src={process.env.PUBLIC_URL + "/img/proof/" + img} alt="" />
        </div>
    )
}
